import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted } from "vue";
import { store } from "@/store/store";
import { useRouter } from "vue-router";
import AgsDataService from "@/services/AgsDataService";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/abrs/Loading.vue";

import * as bootstrap from "bootstrap";
import Compressor from "compressorjs";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const vinNo = ref("");
const failureText = ref(false);
const file = reactive([]);
const url = ref("");
const compressedFile = reactive([]);
const isLoading = ref(false);
const ocrError = ref(false);
const postTieDataValidationError = ref(false);
const serialNo = ref("");
const resultModal = ref("");
const vinNoPattern = ref("");

onMounted(function () {
  getSerialNo();
});

// 選択画像取得
const selectedFile = (event) => {
  isLoading.value = true;
  ocrError.value = false;
  postTieDataValidationError.value = false;
  event.preventDefault();
  file.value = event.target.files[0];
  if(file.value){
    url.value = URL.createObjectURL(file.value);
    compress(file.value);
  } else {
    url.value = ""
    isLoading.value = false;
  }
};

const compress = (file) => {
  const payload: Compressor.Options = {
    quality: 0.7,
    maxWidth: 600,
    maxHeight: 600,
    mimeType: "image/jpeg",
    success(blob: Blob): void {
      compressedFile.value = blob;
      isLoading.value = false;
    },
    error(err: Error): void {
      isLoading.value = false;
      console.log(err.message);
    },
  };
  new Compressor(file, payload);
};

// ファイル送信
const submitPicture = () => {
  isLoading.value = true;
  ocrError.value = false;
  failureText.value = false;
  postTieDataValidationError.value = false;
  document.getElementById("vinNo").classList.remove("border");
  document.getElementById("vinNo").classList.remove("border-danger");
  document.getElementById("vinNo").classList.remove("border-4");
  const formData = new FormData();
  formData.append("image", compressedFile.value);
  AgsDataService.getVinNoByTextract(formData)
    .then(async (response: ResponseData) => {
      const modal = new bootstrap.Modal(
        document.getElementById("confirmModal")
      );
      vinNo.value = response["data"];
      resultModal.value = "analysis";
      isLoading.value = false;
      modal.show();
    })
    .catch(async (e: Error) => {
      isLoading.value = false;
      ocrError.value = true;
      console.log(e);
    });
};

const submitTieData = () => {
  ocrError.value = false;
  postTieDataValidationError.value = false;
  vinNo.value = fullWidth2HalfWidth();
  vinNo.value = vinNo.value.toUpperCase();
  judgePattern();
  isLoading.value = true;
  failureText.value = false;
  const formData = new FormData();
  formData.append("serialNo", serialNo.value);
  formData.append("vinNo", vinNo.value);
  formData.append("vinNoPattern", vinNoPattern.value);
  if (vinNoPattern.value === "NG") {
    failureText.value = true;
    const modal = new bootstrap.Modal(
        document.getElementById("inputErrorModal")
      );
    isLoading.value = false;
    modal.show();
  } 
  else {
        postTieData();
  }
};


const fullWidth2HalfWidth = () => {
  return vinNo.value.replace(/[^ -~。-゜]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}


const judgePattern = () => {
  if (
    vinNo.value.substr(4,2) !== "S-" ||
    vinNo.value.length !== 12
  ) {
    vinNoPattern.value = "NG";
  } else {
    vinNoPattern.value = "OK";
  }
};

const postTieData = () => {
  isLoading.value = true
  const formData = new FormData();
  formData.append("serialNo", serialNo.value);
  formData.append("vinNo", vinNo.value);
  formData.append("vinNoPattern", vinNoPattern.value);
  AgsDataService.postTieData(formData)
  .then(async (response: ResponseData) => {
    store.dispatch("setVinNo", vinNo.value);
    const modal = new bootstrap.Modal(
      document.getElementById("completeModal")
    );
    isLoading.value = false;
    resultModal.value = "complete";
    modal.show();
    document.addEventListener("hidden.bs.modal", function (event) {
      if (event.target.id === "completeModal") {
        router.push("/judgePattern");
      }
    });
  })
  .catch(async (e: Error) => {
    postTieDataValidationError.value = true;
    isLoading.value = false;
    console.log(e);
  });
}

const inputFix = () => {
  failureText.value = true;
  document.getElementById("vinNo").classList.add("border");
  document.getElementById("vinNo").classList.add("border-danger");
  document.getElementById("vinNo").classList.add("border-4");
};

const validateVinNo = () => {
  if (vinNo.value.length === 12) {
    document.getElementById("vinNo").classList.remove("border");
    document.getElementById("vinNo").classList.remove("border-danger");
    document.getElementById("vinNo").classList.remove("border-4");
  }
};

const getSerialNo = () => {
  serialNo.value = store.getters.serialNo;
};

const returnInitialPage = () => {
  router.push("/")
}

const __returned__ = { router, vinNo, failureText, file, url, compressedFile, isLoading, ocrError, postTieDataValidationError, serialNo, resultModal, vinNoPattern, selectedFile, compress, submitPicture, submitTieData, fullWidth2HalfWidth, judgePattern, postTieData, inputFix, validateVinNo, getSerialNo, returnInitialPage, Loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})